import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = [ 'sidebar', 'hamburger', "submenu"];

  connect() {
    window.onresize = (event) => {
      if (window.innerWidth > 991 && this.sidebarTarget.classList.contains('show')) {
        this.hideSidebar();
      }
    };
    this.submenuTargets.forEach((submenu) => {
      const activeLink = submenu.querySelector('.nav-link.active')
      if (activeLink) {
        submenu.style.display = "block"
      }
    })
  }

  toggleSubmenu(event) {
    event.preventDefault()
    const submenu = event.currentTarget.nextElementSibling
    
    submenu.style.display = (submenu.style.display === "none" || submenu.style.display === "") ? "block" : "none"
  }

  toggleSidebar() {
    if (this.sidebarTarget.classList.contains('show')) {
      this.hideSidebar();
    } else {
      this.showSidebar();
    }
  }

  hideSidebar() {
    this.sidebarTarget.classList.remove('show');
    this.sidebarTarget.classList.remove('shadow');
    this.hamburgerTarget.classList.remove('is-active');
  }

  showSidebar() {
    this.sidebarTarget.classList.add('show');
    this.sidebarTarget.classList.add('shadow');
    this.hamburgerTarget.classList.add('is-active');
  }
}
